// @ts-nocheck

import PropTypes from 'prop-types';
import * as R from 'ramda';
import React, { PureComponent } from 'react';
import { createI13nNode } from 'react-i13n';
import { Link as ReactRouterLink } from 'react-router-dom';

// These are props we will be using to detemine characteristics of the link
// and should not therefore not be passed to through to the child.
// We will omit these before passing all other props through to child.
const BLACKLIST_TO_CHILDREN_PROPS = ['className', 'testid', 'newTab', 'target', 'rel'];

const I13nLink = createI13nNode(
  ReactRouterLink,
  {
    isLeafNode: true,
    bindClickEvent: false,
    follow: true,
  },
  { skipUtilFunctionsByProps: true }
);

class Link extends PureComponent {
  static propTypes = {
    /**
     * Only required prop. Passed directly as-is (no prefixing) as 'data-testid'.
     */
    testid: PropTypes.string.isRequired,
    /**
     * If 'href' passed in, link will represent an external link, utilizing
     * a component. The 'newTab' prop is only relevant
     * in this scenario.
     */
    href: PropTypes.string,
    /**
     * When 'href' prop is passed in AND 'newTab' prop is true (default),
     * will apply target="_blank" and rel="noopener noreferrer" for security.
     */
    newTab: PropTypes.bool,
    /**
     * If passed in, link will represent an internal link, utilizing
     * 'react-router's 'Link' component. Can be the URL itself (string),
     * or an object with 'pathname', 'query', and/or 'hash' properties.
     */
    to: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        pathname: PropTypes.string,
        query: PropTypes.object,
        hash: PropTypes.string,
      }),
    ]),
    /**
     * Callback to fire when the link is clicked.
     */
    onClick: PropTypes.func,
    className: PropTypes.string,
    /**
     * Any other props are passed straight through to the child
     * See list of props react-router takes here:
     * https://github.com/ReactTraining/react-router/blob/v2.8.1/docs/API.md#link
     */
    children: PropTypes.any,
  };

  static defaultProps = {
    newTab: true,
  };

  render() {
    const childProps = {
      className: `standard-link ${this.props.disabled ? 'disabled-link' : 'standard-link__active-link'} ${
        this.props.className
      }`,
      'data-testid': `${this.props.testid}`,
      ...R.omit(BLACKLIST_TO_CHILDREN_PROPS, { ...this.props }),
      ...{ onClick: this.props.disabled ? null : this.props.onClick },
    };

    // external link
    if (this.props.href) {
      return (
        <a {...childProps} target={this.props.newTab ? '_blank' : ''} rel={this.props.newTab ? 'noopener noreferrer' : ''}>
          {this.props.children}
        </a>
      );
    }

    // internal link route
    if (this.props.to) {
      return <I13nLink {...childProps}>{this.props.children}</I13nLink>;
    }

    return <a {...childProps}>{this.props.children}</a>;
  }
}

export default Link;
